import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Per-WORD mask reveal for the hero name. Each word slides up from behind an
 * invisible clip edge. Per-word (not per-letter) — letter-by-letter is the #1
 * AI-slop tell and hurts comprehension. Plain text under reduced-motion.
 */
export const WordReveal = ({
  text,
  className,
  stagger = 0.08,
  delay = 0.12,
  accentPeriod = false,
}) => {
  const reduce = useReducedMotion();
  // pull a trailing "." out so it can render in accent gold on the last word
  const hasPeriod = accentPeriod && text.trim().endsWith(".");
  const clean = hasPeriod ? text.trim().slice(0, -1) : text;
  if (reduce)
    return (
      <span className={className}>
        {clean}
        {hasPeriod && <span style={{ color: "var(--accent)" }}>.</span>}
      </span>
    );

  const words = clean.split(/\s+/).filter(Boolean);
  return (
    <span
      className={className}
      style={{ display: "flex", flexWrap: "wrap", gap: "0 0.28em" }}
    >
      {words.map((word, i) => (
        <span
          key={i}
          style={{
            display: "inline-block",
            overflow: "hidden",
            paddingBottom: "0.1em",
            /* line-height < 1 leaves cap tops outside the line box; give the
               clip headroom without shifting layout */
            paddingTop: "0.12em",
            marginTop: "-0.12em",
          }}
        >
          <motion.span
            style={{ display: "inline-block", willChange: "transform" }}
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{
              duration: 0.65,
              ease: [0.22, 1, 0.36, 1],
              delay: delay + i * stagger,
            }}
          >
            {word}
            {hasPeriod && i === words.length - 1 && (
              <span style={{ color: "var(--accent)" }}>.</span>
            )}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export default WordReveal;
